module.exports = __webpack_public_path__ + "assets/img/fish-skeleton.22482672.png";